import { getType } from 'typesafe-actions'
import _ from 'lodash'

import { withLoadingReducer } from '../loading'

import { CompanyDetailActions } from './actions'
import { CompanyDetailState } from './types'

const initialState: CompanyDetailState = {
  companies: {}
}

export const reducer = (state: CompanyDetailState = initialState, action: CompanyDetailActions): CompanyDetailState => {
  switch (action.type) {
    case getType(CompanyDetailActions.setLoadedCompany): {
      const { payload } = action
      return {
        ...state,
        companies: {
          ...state.companies,
          [payload.companyId]: {
            ...state.companies[payload.companyId],
            company: payload.company,
            officialDocumentsRequested: payload.officialDocumentRequested,
            selectedDocumentCode: payload.selectedDocumentCode,
            fetchedDocuments: payload.fetchedDocuments,
            areDocumentsInPriceList: payload.areDocumentsInPriceList,
            documentsKeyValues: payload.documentsKeyValues,
            documentsLimitReached: payload.documentsLimitReached,
            moreDocumentsAvailable:
              payload.documentsKeyValues.length >
              _.filter(payload.company.reports, r => !_.isEmpty(r.documentDates)).length
          }
        }
      }
    }
    default:
      return state
  }
}

export const companyDetailReducer = withLoadingReducer(reducer, 'companyDetail', initialState)
